import "./ElboRoomHub.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FortLauderdalePulse from "./sections/FortLauderdalePulse";
import TodaysStageRotation from "./sections/TodaysStageRotation";
import TheCityWire from "./sections/TheCityWire";
import The33316RealEstatePortal from "./sections/The33316RealEstatePortal";
import CorporateFamilyHub from "./sections/CorporateFamilyHub";
import StaffPortalEventEntry from "./sections/StaffPortalEventEntry";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function ElboRoomHubPage() {
  return <div>
      <MainNavigation />
      <FortLauderdalePulse />
      <TodaysStageRotation />
      <TheCityWire />
      <The33316RealEstatePortal />
      <CorporateFamilyHub />
      <StaffPortalEventEntry />
      <SecurityIntelligenceFooter />
    </div>;
}